import * as theme from '../../theme';
import VideoPlayer from '../../components/VideoPlayer';
import VideoContext from '../../contexts/VideoContext';
import { useNavigate } from "react-router";
import { Box, Button } from '@mui/material';
import DemoScan from './components/DemoScan';
import ImprintFAQsPublic from './components/ImprintFAQsPublic';

export default function PublicVideo(props) {
  const navigate = useNavigate();

  return (
    <div style={theme.Container.video}>
      <div style={theme.Container.fullMax}>
        <div style={{ ...theme.Container.flexColumn, flex: 1, gap: 10 }}>
          <VideoPlayer videoId={props.videoId} isPublic={true} />
          {props.videoId === VideoContext.DemoScan && (
            <DemoScan />
          )}
          {props.videoId === VideoContext.ImprintRemedy && (
            <ImprintFAQsPublic />
          )}
          {props.videoId === VideoContext.Welcome && (
            <Box sx={{ display: "flex", flexDirection: 'column', width: '100%', gap: 2, marginTop: 4, alignItems: 'center', justifyContent: 'center' }}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => navigate(`/dashboard`)}
              >
                Begin Training
              </Button>
            </Box>
          )}
        </div>
      </div>
    </div>
  );
}